import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Image05 = function Image05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 21h1.0104c.9712 0 1.4567 0 1.7244-.2025a1 1 0 0 0 .3949-.7379c.02-.335-.2493-.7391-.788-1.5471l-3.0104-4.5156c-.4451-.6677-.6677-1.0015-.9482-1.1178a1 1 0 0 0-.7662 0c-.2805.1163-.503.4501-.9482 1.1178l-.7442 1.1163M19 21 11.3155 9.9002c-.4419-.6384-.6629-.9576-.9389-1.0698a1 1 0 0 0-.7532 0c-.276.1122-.497.4314-.9389 1.0698l-5.9463 8.5891c-.563.8132-.8445 1.2199-.8285 1.558a1 1 0 0 0 .3914.747C2.57 21 3.0646 21 4.0537 21zm2-15c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3432-3 3-3 3 1.3431 3 3"
    })
  }));
};
export default Image05;